// 跨年合同mixins
const multiyearMixins = { 
    data(){
      var validatorDeliveryRate = (rule, value, callback) => {
        if (value === '' || value < 85) {
          callback(new Error('到货率必须大于等于85小于等于100'));
        } else {
          callback();
        }
      };
      var validatorAttribute11 = (rule, value, callback) => {
        if (value === '' || value > this.filters.yearSales) {
          callback(new Error('未税销售值必须小于等于含税销售值'));
        } else {
          callback();
        }
      };
      var validatorYearSales = (rule, value, callback) => {
        if (value === '' || value < this.filters.attribute11) {
          callback(new Error('含税销售值必须大于等于未税销售值'));
        } else {
          callback();
        }
      };
      var validatorAttribute15 = (rule, value, callback) => {
        if (value === '' || value > this.filters.yearSales) {
          callback(new Error('线上销售(含税)值必须小于等于销售(含税)'));
        } else {
          callback();
        }
      };
      var validatorTacticsA = (rule, value, callback) => {
        if (value && Number(this.chkstrlen(value)) > 2000) {
          callback(new Error('合同条款字符长度不能超过2000！'));
        } else {
          callback();
        }
      };
      var validatorTacticsB = (rule, value, callback) => {
        if (value && Number(this.chkstrlen(value)) > 2000) {
          callback(new Error('合同条款字符长度不能超过2000！'));
        } else {
          callback();
        }
      };
      var validatorTacticsC = (rule, value, callback) => {
        if (value && Number(this.chkstrlen(value)) > 2000) {
          callback(new Error('合同条款字符长度不能超过2000！'));
        } else {
          callback();
        }
      };
      var vue = this;
        return {
          source: "",       //页面来源
          currentStatus: '',  //合同当前状态
          returnPath: "",    //返回页面
          FZCX:{},
          watchTCF:{},
          watchQT: {},
          watchYXFFW: {},
          resultArr: [], //用来接受返回结果的数组
          GETFZCX: {},
          GETHTCL:{},  //-----------------跨年合同时间修改-----------------------------
          pickerMinDate: '',                       //选中的开始时间
          pickerNum: 0,
          startDateOld: false, //时间控件切换之前开始时间的值
          endDateOld: false, //时间控件切换之前结束时间的值
          contractDate: [], //合同时间
          pickerMaxDates: [],                      //可选结束时间数组
          pickerOptions: {
            // 选中日期后会执行的回调，只有当 daterange 或 datetimerange 才生效
            onPick: ({ maxDate, minDate }) => {
              this.pickerMinDate = this.$moment(minDate).format("YYYY-MM-DD");
              this.pickerNum++;
              if(this.pickerNum == 1){
                this.getDateInfoByStartDate(this.pickerMinDate);
              }
              if (maxDate) {
                this.year = this.prestoreYear;
                this.clearPickerDate();
              }
            },
            disabledDate(time) {
              return time.getTime() < Date.now() - 8.64e7 || vue.disabledEndDate(time);    
            },
          },
          show2021:false,
          year:null,
          prestoreYear: null,    //选中开始时间之后预存年份，选完结束时间再给年份赋值
          supObj:{
            supplier: 0, //供应商编码
            supName: "", //供应商名称
            contractType: "", //经营方式
            contactPhone: "", //联系人电话
            qualification: "", //供应商资质
            termsDesc:'', //账期计算方式
            paymentMethod:'', //支付方式
            advancePaymentInd : "Y", //是否预付款
          },
          rebateVisible: false, //返利弹窗
          saveVisible: false, // 保存弹窗
          yearLimit: {
            disabledDate(time) {
              return time.getTime() < Date.now() + 1;
            },
          },
          rebateLadder2: "", //有条件返利阶梯
          rebateLadder:'', //有条件返利阶梯
          rebateLadderChange:'', //有条件返利阶梯
          IsDisabled: false,
          contractLocalid: 0, //合同号ID
          contractId: 0,
          yearId: '',
          isCheck: false,
          isCheckSave: true,
          isCheckChange:false,
          filtersRules: {
            // 校验
            brandNames: [{ required: true, message: "请填写", trigger: "change" }],
            attribute1: [{ required: true, message: "请填写", trigger: "change" }],
            attribute8: [{ required: true, message: "请填写", trigger: "change" }],
            attribute11: [{ required: true, validator: validatorAttribute11, trigger: "change" }],
            marginRate: [{ required: true, message: "请填写", trigger: "change" }],
            yearSales: [{ required: true, validator: validatorYearSales, trigger: "blur" }],
            attribute15: [{ required: true, validator: validatorAttribute15, trigger: "blur" }],
            representative: [{ required: true, message: '请输入公司法人代表', trigger: 'blur' }],
            attribute16: [{ required: true, message: '请选择', trigger: 'change' }],
            returnSign: [{ required: true, message: "请填写", trigger: "change" }],
            deliveryRate: [{ required: true,validator: validatorDeliveryRate, trigger: "blur" }],
            isMerge: [{ required: true, message: "请填写", trigger: "change" }],
            refNo2: [
              { required: true, message: '新品优先上市约定未选择', trigger: 'change' }
            ],
            refNo3:[ { required: true, message: '库存周转天数未填写', trigger: 'blur' }],
            contractTacticsA:[{required: true, validator: validatorTacticsA, trigger: 'change'}],
            contractTacticsB:[{required: true, validator: validatorTacticsB, trigger: 'change'}],
            contractTacticsC:[{required: true, validator: validatorTacticsC, trigger: 'change'}],
            refNo4:[ { required: true, message: '分享佣金未填写', trigger: 'blur' }],
          },
          businessType: "",
          params: {},
          previewOne:'',
          contractSupplierQualificationList:[],
          contractTypeList:[],
          contractPayMethodList:[],
          attribute16List:[],
          supplierParent:'',
          groupNo:'',
          rebateLadderShow:'',
          invoiceType: [], //发票类型
          invoiceTypeError: false, //发票类型未选择时报错信息展示
          sendersWay:[],           //固定价格补差方式
          BCCLFLAG:false,
          isContractTypeLY:true, //判断是否联营就给合同策略传值
          saveLoading:false,
          show2022: false,
          currentYear: ''
        }
    },
    methods: {
        //判断中文加2个字符，否则加1个字符
        chkstrlen(str){
    　　　　var strlen = 0;
    　　　　for(var i = 0;i < str.length; i++){
    　　　　　　if(str.charCodeAt(i) > 255) //如果是汉字，则字符串长度加2
    　　　　　　　　strlen += 3;  //数据库编码不同一个中文3个字节，所以前台改为3
    　　　　　　else 
    　　　　　　　　strlen++;
    　　　　}
    　　　　return   strlen;
    　　},
        inputhandle(str) {
          if (str.value && Number(this.chkstrlen(str.value)) > 2000) {
            this.$message.error(`合同条款字符长度不能超过2000！`); 
            return false;
          } else {
            return true;
          }
        },
        getUpdateFlag(data){
          this.BCCLFLAG = data;
        },
        getFlag(data){
        },
        getRows() {
          let para = {
            supplier: JSON.parse(sessionStorage.getItem("userInfo")).id
          };
          this.$api.contract.getDefaultValue(para).then(res => {
            if (res.data.code == "0000") {
              this.supObj = {...res.data.result[0]};
              this.supObj.supplierName = res.data.result[0].supName;
              this.supObj.contractType =  res.data.result[0].businessType;
              this.businessType = res.data.result[0].businessType;
              this.supObj.qualification = res.data.result[0].businessProperty;
              this.supplierParent= res.data.result[0].supplierParent;
              this.groupNo = res.data.result[0].groups;
              this.$forceUpdate();
              if(this.filters.year  !== 2020){
                this.show2021 = true;
              }else{
                this.show2021 = false;
              }
              if(this.supplierParent != ''){
                let para = {
                  supplier:res.data.result[0].supplierParent,
                }
                this.$api.contract.getDefaultValue(para).then(res => {
                  if(res.data.code == '0000'){
                    this.supObj.paymentMethod = res.data.result[0].paymentMethod;
                    this.$forceUpdate();
                  }
                })
              }
            }
          });
        },
        //清空textarea内容
        resetTextarea(){
          this.rebateLadder2 = '';
        },
        //发票类型change事件
        invoiceTypeChange(val){
          this.invoiceType = val;
          if(this.invoiceType < 1){
            this.invoiceTypeError = true;
          }else{
            this.invoiceTypeError = false;
          }
        },
        //当时间控件 失去焦点时清空已选中的开始时间
        clearPickerDate(){
          this.pickerMinDate = "";
          this.pickerNum = 0;
        },
        //根据选中的开始时间获取可选的结束时间
        async getDateInfoByStartDate(startTime){
          let res = await this.$api.contract.getDateInfoByStartDate({startDate: startTime});
          let { data, status } = res;
          if (status === 200) {
            data = data.result;
            this.pickerMaxDates = data.endDate;
            this.prestoreYear = data.year;
            this.filters.year = data.year.toString();
            
          }else{
            this.$message.error('查询当前可选结束日期失败!' + msg);
          }
        },
        //结束时间可选
        disabledEndDate(time){
          if (this.pickerMinDate) {
            //因只需对比日期，所以转成YYYY-MM-DD之后再new Date(dateTime).getTime();
            let dateTime = this.$moment(time).format("YYYY-MM-DD");
            let time2 = []; //返回的可选结束日期转为时间戳的数组
            for(let i=0;i<this.pickerMaxDates.length;i++){
                time2.push(new Date(this.pickerMaxDates[i]).getTime());
            }
            var t = new Date(dateTime).getTime();  //当前面板里的时间戳
            if(time2.indexOf(t)==-1){
              //disabledDate属性：true为禁用，false为可用  如果面板里的时间戳不包含在可选时间戳里面则禁用
              return true;
            }
          }
        },
        //修改合同时间
        changeContractDate() {
          this.$confirm('是否确认修改合同时间?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let _this = this;
            _this.startDateOld = _this.contractDate[0];
            _this.endDateOld = _this.contractDate[1];
            // 合同开始时间>=2021.11.30显示
            _this.show2022 = _this.startDateOld.split('-')[0]>=2022 || (_this.startDateOld.split('-')[0]==2021&&_this.startDateOld.split('-')[1]==12)
          }).catch(() => {
            let _this = this;
            _this.filters.startDate = _this.startDateOld;
            _this.filters.endDate = _this.endDateOld; 
            _this.combineContractDate();
          });
        },
        combineContractDate() {
          if (this.filters.year == null) {
            return
          } else {
            if (this.filters.startDate == null && this.filters.year) {
              this.filters.startDate = this.filters.year + '-01-01';
              this.filters.endDate = this.filters.year + '-12-31';
            }
            var start = new Date(this.filters.startDate);
            var end = new Date(this.filters.endDate);
            start.setTime(start.getTime());
            end.setTime(end.getTime());
            this.contractDate = [start, end];
            this.contractDate[0] = this.splitDate(this.contractDate[0]);
            this.contractDate[1] = this.splitDate(this.contractDate[1]);
          }
        },
        //获取复杂促销的值
        getFZCXformSon(data){
            this.FZCX = data;
        },
        //获取合同策略 特陈费 的值
        getTCFformSon(data){
            this.watchTCF = data;
        },
        //获取合同策略 营销服务费 的值
        getYXFFWformSon(data){
            this.watchYXFFW = data;
        },
        //获取合同策略 其他 的值
        getQTformSon(data){
            this.watchQT = data;
        },
        //补差方式
        decomposeSendersWay(){
          this.filters.fund0Method = "N";
          this.filters.fund1Method = "N";
          this.filters.fund2Method = "N";
          for(let i=0;i<this.sendersWay.length;i++){
            if(this.sendersWay[i]=="1"){
              this.filters.fund0Method = "Y"
            }else if(this.sendersWay[i]=="2"){
              this.filters.fund1Method = "Y"
            }else if(this.sendersWay[i]=="3"){
              this.filters.fund2Method = "Y"
            }
          }
        },
        //保存时过滤，字段有值的才传给后台
        filterObj(obj){
          let objNEW = {};
          for (var key in obj) {
            if (obj[key] != null && obj[key] != undefined) {
              objNEW[key] = obj[key];
            } 
          }
          return objNEW;
        },
        //保存跨年合同-申报简表
        saveMultiYear(filtersName,zy){ 
          this.filters.createdBy = this.$getUserId();
          this.filters.groupNo = this.groupNo;
          this.filters.supplier =  this.$getUserId();
          this.filters.supplierName = this.$getUserName();
          this.filters.contractType = this.businessType;
          this.filters.qualification = this.supObj.qualification;
          this.filters.paymentMethod = this.supObj.paymentMethod;
          this.filters.contactPhone = this.supObj.contactPhone;
          this.filters.inItemDiscount = this.filters.inItemDiscount;
          this.filters.startDate =this.contractDate[0];
          this.filters.endDate =this.contractDate[1];
          if(zy){
            if(this.rebateLadder2 !== '' && this.rebateLadder2 !== null){
              this.filters.rebateLadder = this.rebateLadder;
            }else {
                this.filters.rebateLadder = []
            }
          }
          this.filters.contractType = this.businessType;
          if(this.show2021 == true){
            let FZCX = {};
            FZCX = this.filterObj(this.FZCX);
            // 2022促销补差策略 系统时间 || 合同开始时间>=2021.12
            if (this.show2022 || this.currentYear>=2022) {
              let {sendersWay, ...obj} = FZCX
              this.filters.cxbccl ={"FZCX2022": obj};
              this.sendersWay = sendersWay
            } else {
              this.filters.cxbccl ={"FZCX": FZCX};
            }
            let HTCL = {};
            if(this.watchTCF || this.watchYXFFW || this.watchQT){
              this.filters.htcl = HTCL;
            }
            let TCF = Object.keys(this.filterObj(this.watchTCF));
            let YXFFW = Object.keys(this.filterObj(this.watchYXFFW));
            let QT = Object.keys(this.filterObj(this.watchQT));
            if(TCF.length > 0){
              HTCL.TCF = this.filterObj(this.watchTCF);
            }
            if(YXFFW.length > 0){
              HTCL.YXFFW = this.filterObj(this.watchYXFFW);
            }
            if(QT.length > 0){
              HTCL.QT = this.filterObj(this.watchQT);
            }
            var p1=new Promise((resolve,reject)=>{
              this.$refs['ContractStrategy'].$refs['TCF'].validate(valid=>{
                if(valid){
                  console.log('1')
                    resolve()
                  } else{
                    return false;
                  }
              })
            })
            var p2=new Promise((resolve,reject)=>{
              this.$refs['ContractStrategy'].$refs['YXFFW'].validate(valid=>{
                  if(valid){
                    console.log('2')
                    resolve()
                  }  else{
                    return false;
                  }
                })
            })
            var p3=new Promise((resolve,reject)=>{
              this.$refs['ContractStrategy'].$refs['QT'].validate(valid=>{
                if(valid){
                  console.log('3')
                  resolve()
                } else{
                  return false;
                } 
              })
            })
            var p4=new Promise((resolve,reject)=>{
              this.$refs[filtersName].validate(valid => {
                  if(valid){
                    console.log('5')
                    resolve()
                  } else{
                    this.$message({
                      message: "请填写完整信息再保存",
                      type: "error"
                    });
                    return false;
                  }
              })
            })
            this.$refs.ContractSalesPromotion.validateOther();
            //用来判断补差策略的校验是否通过
            if(!this.BCCLFLAG){
              return false;
            }
            if(zy){
              if(this.filters.refNo2 == 0){
                this.$message.error('请填写新品优先上市约定');
                return false;
              }
            }
          }
          this.decomposeSendersWay();
          if(zy){
            if(this.invoiceType.length < 1){
              this.invoiceTypeError = true;
              this.$message.error('请填写乙方提供发票类型');
              return false;
            }else{
              this.filters.invoiceType = this.invoiceType.length > 0 ? this.invoiceType.toString() : '';
            }
          }
          if(this.isAdd){
            //如果是2021年模版 就校验多个表单
            if(this.show2021 == true){
              Promise.all([p1,p2,p3,p4]).then(()=>{ 
                this.saveLoading = true; 
                this.$api.contract.saveDeclarationFormNew(this.filters).then(res => {
                  if (res && res.data.code == "200" && res.data.msg == 'success') {
                    this.contractId = res.data.result;
                    this.yearId = this.filters.year.toString();
                    this.saveVisible = true;
                    this.saveLoading = false; 
                  }else{
                    this.$message.error(`保存失败 ${res.data.msg}`);
                    this.saveLoading = false; 
                  }
                }).catch(() => {
                  this.saveLoading = false; 
                });
              }).catch((err) => {
                this.$message({
                  message: "请填写完整信息再保存",
                  type: "error"
                });
                this.saveLoading = false; 
                return false;
              });
            }else{
              //如果是2020年模版，就只用校验一个表单 
              this.$refs[filtersName].validate(valid => {
                if (valid) {
                  this.saveLoading = true; 
                  this.$api.contract.saveDeclarationForm(this.filters).then(res => {
                    if (res && res.data.code == "200" && res.data.msg == "success") {
                      this.contractId = res.data.result;
                      this.yearId = this.filters.year.toString();
                      this.saveVisible = true;
                      this.saveLoading = false; 
                    } else {
                      this.$message.error(`保存失败 ${res.data.msg}`);
                      this.saveLoading = false; 
                    }
                  }).catch(() => {
                    this.saveLoading = false; 
                  });
                } else {
                  this.$message({
                    message: "请填写完整信息再保存",
                    type: "error"
                  });
                  this.saveLoading = false; 
                  return false;
                }
              });
            }
          }else if(this.isEdit){
            this.filters.inItemDiscount = this.filters.inItemDiscount;
            this.filters.marginRate = Number(this.filters.marginRate);
            this.filters.membersAmount = Number(this.filters.membersAmount);
            this.filters.currentStatus = this.currentStatus;
            if((this.rebateLadder2 !== '') && (this.rebateLadder2 !== null) && (this.rebateLadderShow !== '' && this.rebateLadderShow !== this.rebateLadderChange)){
                this.filters.rebateLadder = this.rebateLadderShow;
            }else if((this.rebateLadder2 !== '') && (this.rebateLadder2 !== null) && (this.rebateLadderChange == this.rebateLadderChange)){
                this.filters.rebateLadder = this.rebateLadderChange;
            }else {
              this.filters.rebateLadder = []
            }
            //如果是2021年模版 就校验多个表单
            if(this.show2021 == true){
              Promise.all([p1,p2,p3,p4]).then(()=>{ 
                this.saveLoading = true; 
                this.$api.contract.updatevssContractNew(this.filters).then(res => {
                  if (res && res.data.code == "200" && res.data.msg == 'success') {
                    this.$message({
                      message: "修改成功",
                      type: "success"
                    });
                    this.saveLoading = false; 
                    this.$router.push("/contractManager/purchasecontract");
                  }else{
                    this.saveLoading = false; 
                    this.$message.error(`修改失败 ${res.data.msg}`);
                    this.saveLoading = false; 
                  }
                }).catch(() => {
                  this.saveLoading = false; 
                });
              }).catch((err) => {
                this.$message({
                  message: "请填写完整信息再保存",
                  type: "error"
                });
                this.saveLoading = false; 
                return false;
              });
            }else{
              //如果是2020年模版，就只用校验一个表单 
              this.$refs[filtersName].validate(valid => {
                if (valid) {
                  this.saveLoading = true; 
                  this.$api.contract.updatevssContract(this.filters).then(res => {
                    if (res && res.data.code == "200" && res.data.msg == "success") {
                      this.$message({
                        message: "修改成功",
                        type: "success"
                      });
                      this.saveLoading = false; 
                      this.$router.push("/contractManager/purchasecontract");
                    } else {
                      this.saveLoading = false; 
                      this.$message.error(`修改失败 ${res.data.msg}`);
                      this.saveLoading = false; 
                    }
                  }).catch(() => {
                    this.saveLoading = false; 
                  });
                } else {
                  this.$message({
                    message: "请填写完整信息再保存",
                    type: "error"
                  });
                  this.saveLoading = false; 
                  return false;
                }
              });
            }
          }
        },
        // 获取查看数据
        getList(event, callback) {
          var _this = this;
          let para = {
            contractLocalid: this.contractLocalid
          };
          this.$api.contract.getVssContractInfo(para).then(res => {
            if(res && res.data.code =='200' && res.data.msg == 'success'){
              this.filters = Object.assign({},res.data.result);
              this.filters.logisticsAuxiliary = res.data.result.logisticsAuxiliary;
              this.filters.logisticsTransportation = res.data.result.logisticsTransportation;
              this.filters.serveAndConsumables = res.data.result.serveAndConsumables;
              this.filters.membersAmount = res.data.result.membersAmount;
              this.filters.yearSales = res.data.result.yearSales;
              this.filters.attribute1 = res.data.result.attribute1;
              this.filters.attribute8 = res.data.result.attribute8;
              this.filters.attribute11 = res.data.result.attribute11;
              this.filters.inItemDiscount = res.data.result.inItemDiscount;
              this.filters.marginRate = res.data.result.marginRate;
              this.filters.refNo2 = +this.filters.refNo2;
              this.year = res.data.result.year;
              if(this.year != 2020 && this.year < 2022){
                this.show2021 = true;
                this.GETFZCX = Object.assign({},res.data.result.cxbccl.FZCX);
                this.GETHTCL = Object.assign({},res.data.result.htcl);
              }else if(this.year >= 2022){
                this.show2022 = true
                this.GETFZCX = Object.assign({},res.data.result.cxbccl.FZCX2022, {
                  sendersWay: []
                });
                this.GETHTCL = Object.assign({},res.data.result.htcl);
              }else{
                this.show2021 = false;
              }
              var start = new Date();
              var end = new Date();
              start.setTime(start.getTime());
              end.setTime(end.getTime());
              this.contractDate = [start, end];
              this.contractDate[0] = this.splitDate(res.data.result.startDate);
              this.contractDate[1] = this.splitDate(res.data.result.endDate);
              this.invoiceType = this.filters.invoiceType ? this.filters.invoiceType.split(",") : []; //发票类型
              let rebate = res.data.result.rebateLadder;
              let str = '';
              if(rebate == null || rebate == ''){
                this.rebateLadder2 = ''
              }else{
                rebate.forEach(item => {
                  str += item.lowerValue+'<n<'+item.upperValue+' '+item.value+'%'+'\n';
                })
                this.rebateLadder2 =str;
              }
              this.rebateLadderChange = rebate;
              this.filters.year = res.data.result.year.toString();
              this.combineSendersWay();
              this.show2022 && (this.GETFZCX.sendersWay = this.sendersWay)
              this.$forceUpdate();
            }
            callback&&callback()
          });
        }, 
        combineSendersWay(){
          if(this.filters.fund0Method == "Y"){
            this.sendersWay.push("1");
          }
          if(this.filters.fund1Method == "Y"){
            this.sendersWay.push("2");
          }
          if(this.filters.fund2Method == "Y"){
            this.sendersWay.push("3");
          }
        },
    },
    created(){
        let param = JSON.parse(sessionStorage.getItem('param'));
        this.source = param.source || "detail";
        this.currentStatus = param.currentStatus || '';
        var myDate = new Date();
        this.currentYear = myDate.getFullYear()
        let monthVal = myDate.getMonth()+1
        // 2021.12月开始按2022的逻辑显示
        if (monthVal > 11) {
          this.currentYear++
        }
    },
    computed: { //后台费用合计＝会员营销服务费+翔龙费用 +特殊位置服务费+DM海报费+（进货折扣+信息服务费%）*含税净入库
      totalExpenses() {
        return (
          Number(this.filters.membersAmount) +
          Number(this.filters.attribute10) +
          Number(this.filters.specialAmount) +
          Number(this.filters.dmAmount) +
          (Number(this.filters.inItemDiscount) +
            Number(this.filters.messageServe)) *
            Number(this.filters.attribute1)
        );
      },
      //后台费用率%＝后台费用合计/未税销售
      expenseRatio() {
        if (Number(this.filters.attribute11) == 0) {
          return 0;
        }
        return Number(this.totalExpenses) / Number(this.filters.attribute11);
      },
      //综合毛利率%（不含DC）＝销售平均毛利率+后台费用率
      grossMargin() {
        return Number(this.filters.marginRate) + Number(this.expenseRatio);
      },
      //综合毛收入率（含DC）＝综合毛利率+DC额/未税销售*100%
      grossRevenueRate() {
        if (Number(this.filters.attribute11) == 0) {
          return 0;
        }
        return (
          (Number(this.grossMargin) / Number(this.filters.attribute11)) * 100
        );
      },
      isLook(){
        return this.source=="detail";
      },
      isEdit(){
        return this.source=="edit";
      },
      isAdd(){
        return this.source=="add";
      },
    }, 
    watch: {
      year: function (val, oldVal) {
        if(val != 2020){
          this.show2021 = true;
        }else{ 
          this.show2021 = false;
        }
      },
    },
};
export default multiyearMixins;


// WEBPACK FOOTER //
// ./src/mixins/multiyearcontract.js